import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
import { Lock } from 'lucide-react';
import { usePriceConfig } from './PriceContext';
export function PricingSection() {
  const price = usePriceConfig();
  const items = [{
    name: 'Sistema Maestro de Carpintería con +200 Planos',
    price: 19.00
  }, {
    name: 'Muebles Funcionales',
    price: 15.99
  }, {
    name: 'Acabados y Terminaciones Premium',
    price: 9.99
  }, {
    name: 'Guía de Herramientas Indispensables',
    price: 7.99
  }, {
    name: 'Calculadora de Rentabilidad',
    price: 14.99
  }, {
    name: 'Plan Maestro de Negocio Rentable',
    price: 15.99
  }, {
    name: 'Protocolo de Seguridad Profesional',
    price: 7.99
  }, {
    name: 'Planos Pro de Muebles de Melamina',
    price: 15.99
  }, {
    name: 'Sistema Profesional de Correderas y Herrajes™',
    price: 15.99
  }, {
    name: 'Muebles de Alto Valor: Cómodas y Roperos Profesionales™',
    price: 13.99
  }];
  const totalValue = items.reduce((sum, item) => sum + item.price, 0);
  return <section id="pricing-section" className="py-8 md:py-16 px-4 bg-metal bg-blueprint scroll-mt-16" data-id="element-146">
      <div className="max-w-2xl mx-auto" data-id="element-147">
        <div className="text-center mb-8 md:mb-12" data-id="element-148">
          <h2 className="text-3xl md:text-5xl font-black text-[#E4D6B5] mb-4 md:mb-6 uppercase tracking-tight" data-id="element-149">
            ¿Cuánto Cuesta Todo Esto?
          </h2>
        </div>

        <div className="bg-leather border-2 md:border-8 border-[#8B5A2B] shadow-[0_0_60px_rgba(139,90,43,0.4)] overflow-hidden" data-id="element-150">
          
            <img src="https://cdn.shopify.com/s/files/1/1045/1160/3027/files/image_42_1.webp?v=1771866953" alt="Método de Carpintería Plegable" className="w-full h-auto max-w-sm object-contain" loading="lazy" decoding="async" width="384" height="384" data-id="element-151" />
          
        <div className="p-6 md:p-8" data-id="element-152">
            {/* Items List - localized suffix */}
            

            
          

            {/* Total Value - localized suffix */}
            <div className="mb-6 md:mb-8 pb-4 border-b-2 border-[#8B5A2B]" data-id="element-153">
              <div className="flex items-center justify-between" data-id="element-154">
                <span className="text-lg md:text-xl font-black text-[#E4D6B5] uppercase" data-id="element-155">
                  Valor Total:
                </span>
                <span className="text-2xl md:text-3xl font-black text-[#8B5A2B]" data-id="element-156">
                  {totalValue.toFixed(2)}
                  {price.itemSuffix}
                </span>
              </div>
            </div>

            {/* Today's Price Box */}
            <div className="bg-[#111111] text-white p-6 md:p-8 border-2 md:border-4 border-[#6F6F6F] mb-6 text-center" data-id="element-157">
              <p className="text-sm md:text-base font-semibold mb-3 uppercase tracking-wide text-[#E4D6B5]" data-id="element-158">
                Hoy Accedes Por Un Pago Único De:
              </p>
              <p className="text-5xl md:text-6xl font-black text-[#8B5A2B] mb-4" data-id="element-159">
                {price.main}
              </p>

              <CTAButton text="AGREGAR AL CARRITO" size="large" className="w-full mb-4" data-id="element-160" />

              <p className="text-xs md:text-sm font-semibold mb-2 text-[#C8B894]" data-id="element-161">
                Acceso Inmediato a +200 Planos + 9 Bonos
              </p>

              <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-[#C8B894]" data-id="element-162">
                <Lock className="w-4 h-4" data-id="element-163" />
                <span data-id="element-164">
                  Pago único. SIN cargos mensuales. SIN costos ocultos.
                </span>
              </div>
            </div>

            <p className="text-xs md:text-sm text-[#C8B894] text-center italic" data-id="element-165">
              Garantía 7 Días - 100% Reembolso
            </p>
          </div>
        </div>

        {/* Final Warning */}
        <div className="bg-[#8B5A2B] text-[#E4D6B5] p-6 md:p-8 border-4 border-[#6F6F6F] shadow-lg text-center mt-8" data-id="element-166">
          <p className="text-sm md:text-lg font-semibold" data-id="element-167">
            Esta oferta especial de lanzamiento va a cerrar pronto.
          </p>
        </div>
      </div>
      <div className="divider-industrial mt-8 md:mt-16" data-id="element-168"></div>
    </section>;
}